import { BaseService, IGetList } from '../base/base.service';
import { AppService } from '../main/app.service';

export class INewsItem {
    id: string;
    title: string;
    text: string;
    newsItemTypeList: string[];
    createdDate: any;
    expireDate: any;
}

export class NewsService extends BaseService<INewsItem> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'newsItem');
    }

    public getUnread = (): ng.IPromise<IGetList<INewsItem>> => {
        return this.Restangular.all(this.itemName).customGET('unread', {}).then((response: Restangular.ICollection) => {
            return this.getListLoaded(response.plain());
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/news.service.ts